export const emailRegexp = /^([a-zA-Z0-9\-\.\_]{1,})@([a-zA-Z0-9\-\_]{1,}\.){1,}([a-zA-Z0-9]{2,})$/g

// Vynuceny specialni znak
// export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,50}$/g

// Povolene specialni znaky, ale nejsou vynucene
export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@!%*?&_.,-]{8,50}$/g

export const phoneNumberRegexp = /^[\d\s+\/-]*$/g
